"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.student = exports.default = void 0;

var _getAuth = _interopRequireDefault(require("./getAuth"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getStudentFromResults = students => students.at(0);
/**
 * Memoized version of getStudents so that as long as we are getting the same student we aren't hitting datastore multiple times
 */


const student = {
  cache: {},

  clearMemoization() {
    this.cache = {};
  },

  getStudentMemoized() {
    return async datastore => {
      const sisStudentid = await (0, _getAuth.default)({
        datastore
      }); // If there is no sisStudentid in the payload then we won't get a student back from a datastore call so skip straight to resolving the empty array

      if (!sisStudentid) {
        return Promise.resolve({});
      } // Get the student sis id in a format that we can store the result agains


      const argsString = JSON.stringify(sisStudentid); // If this already exists in the cache let's return that

      if (this.cache[argsString]) {
        return this.cache[argsString].then(getStudentFromResults);
      } // actually get the student here


      const result = datastore.collection("students").where("sisStudentid", "===", sisStudentid).get(); // Store the result in the cache

      this.cache[argsString] = result; // Return the result

      return result.then(getStudentFromResults);
    };
  }

};
exports.student = student;
const getStudent = student.getStudentMemoized();
var _default = getStudent;
exports.default = _default;